import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "reactstrap";

import { ProfileImageUpload } from "../../CommonElements/ProfileImageUploader/ProfileImageUpload";
import { useAppDispatch } from "../../ReduxToolkit/Hooks";
import { updateExternalUser } from "../../ReduxToolkit/Reducers/UserManagement";
import { uploadFileApi } from "../../ReduxToolkit/Reducers/UserSlice";
import { extractFileName, fileUrlKeys } from "../../utils/helper/helper";
import {
  getFromLocalStorage,
  LOGGED_IN_USER,
  saveToLocalStorage,
} from "../../utils/helper/localStorageutils";

import ProfileDetail from "./ProfileDetail";
import "./style.scss";

interface ProfileDetailData {
  id: number;
  icon: string;
  title: string;
  detail: string;
}

interface ProfileData {
  userProfileUrl: string;
  name: string;
  designation: string;
  userDetails: ProfileDetailData[];
}

interface ProfileDataProps {
  userData: ProfileData;
  loggedInUserDetailsList?: any;
  getProfile?: any;
  showEdit?: boolean;
}

const UserProfileCard: React.FC<ProfileDataProps> = ({
  userData,
  loggedInUserDetailsList = {},
  getProfile = () => {
    return;
  },
  showEdit = false,
}) => {
  const dispatch = useAppDispatch();
  const [previewUrl, setPreviewUrl] = useState<any>(
    userData?.userProfileUrl || ""
  );
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  useEffect(() => {
    const loginData = getFromLocalStorage(LOGGED_IN_USER);
    if (loginData) {
      loginData.profile_url = userData?.userProfileUrl;
      saveToLocalStorage(LOGGED_IN_USER, loginData);
      setPreviewUrl(userData?.userProfileUrl);
    }
  }, [userData?.userProfileUrl]);

  const uploadFile = async documents => {
    const postData = new FormData();
    documents?.forEach(file => {
      postData.append("files", file);
    });
    const response = await dispatch(
      uploadFileApi({ content: postData, key: fileUrlKeys?.profiles })
    );
    return response?.payload?.data?.file_urls;
  };

  const handleImageChange = (file: File) => {
    let imageUrl = userData?.userProfileUrl;
    if (file) imageUrl = URL.createObjectURL(file);
    setPreviewUrl(imageUrl);
    setSelectedFile(file);
  };

  const handleImageUpload = async () => {
    let uploadedFile = "";
    if (selectedFile) {
      uploadedFile = await uploadFile([selectedFile]);
    } else {
      uploadedFile = fileUrlKeys?.profiles + "/" + extractFileName(previewUrl);
    }

    if (previewUrl === null || previewUrl === "") {
      uploadedFile = "";
    }

    const payload: any = {
      id: loggedInUserDetailsList?.[0]?.id,
      is_update: 1,
      is_profile_url: true,
      profile_url: selectedFile ? uploadedFile?.[0] : uploadedFile || "",
    };
    await dispatch(updateExternalUser({ payload: payload }));
    await getProfile();
  };

  return (
    <>
      <Row>
        <Col md="12" sm="12">
          <Card className="user-profile-hovercard">
            <div className="user-profile-cardheader">
              <></>
            </div>
            <div className="user-profile-avatar text-center">
              <div className="mb-8">
                <ProfileImageUpload
                  currentImage={previewUrl}
                  onImageChange={handleImageChange}
                  handleImageUpload={handleImageUpload}
                  showEdit={showEdit}
                />
              </div>
            </div>
            <ProfileDetail profileDetailData={userData} />
          </Card>
        </Col>
      </Row>
    </>
  );
};

UserProfileCard.propTypes = {
  userData: PropTypes.exact({
    userProfileUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    percentage: PropTypes.number.isRequired,
    expertiseLevel: PropTypes.string.isRequired,
    userDetails: PropTypes.arrayOf(
      PropTypes.exact({
        id: PropTypes.number.isRequired,
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        detail: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  loggedInUserDetailsList: PropTypes.any,
  getProfile: PropTypes.any,
  showEdit: PropTypes.bool,
};

export default UserProfileCard;
